import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getter'
import app from './modules/app'
import article from './modules/article'
import user from './modules/user'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    app,
    user,
    article
  },
  getters
})

export default store



//////////////////
// WEBPACK FOOTER
// ./app/store/index.js
// module id = null
// module chunks = 